import { h } from 'preact';

const render = () => (
	<div>
		<script type="text/javascript" dangerouslySetInnerHTML=
			{{__html: `
				!function(e){window.OperamPixelObjectName=e,window[e]=window[e]||{_queue:[],_id:null,_loadScript:function(e){var t=document.createElement("script");t.type="text/javascript",t.async=!0,t.src=e,document.getElementsByTagName("head")[0].appendChild(t)},_push:function(e,t){this._queue.push({eventId:e,data:t})},addIntoAudience:function(e,t){var n="[object Array]"===Object.prototype.toString.call(e);return n&&(e=e.join(" >> ")),this._push("ADD_INTO_AUDIENCE",{audienceName:e,customData:t}),e},trackConversion:function(e,t,n,i){this._push("TRACK_CONVERSION",{orderId:e,revenue:t,sellerId:n,currency:i})},load:function(e,t){this._id=e,this._isTest=t,this._loadScript("https://js.uadx.com/v2/pixel.js")}}}("operam");
				operam.load('17097db6-299c-49ad-8919-f8b991bfb515');
			`}}
		/>
	</div>
);

export {
	render
};
